// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__24-7K","topBottomGutter":"Layout_topBottomGutter__3wIAl"};